import { send } from 'server';

export const TAG_NAME = 'uam/pub/unauthorized_access_notification';

export const getPlayerTags = () => send({
    ID: 35547,
    responses: [35548, 35549],
    description: 'Get Player Tags Request',
    tagName: TAG_NAME
});

export const updatePlayerTags = value => send({
    ID: 35544,
    responses: [35545, 35546],
    description: 'Set Player Tags Request',
    tags: [
        {
            name: TAG_NAME,
            value,
            type: 'text'
        }
    ]
});

